import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { DateRangeProvider } from "@/context/DateRangeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Learn from "@/pages/Learn";
import PaymentReturn from "@/pages/PaymentReturn";

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <DateRangeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/learn" element={<Learn />} />
              <Route path="/learn/:sectionSlug/:pageSlug" element={<Learn />} />
              <Route path="/payment/success" element={<ProtectedRoute><PaymentReturn /></ProtectedRoute>} />
              <Route path="/payment/cancel" element={<ProtectedRoute><PaymentReturn cancel /></ProtectedRoute>} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" />
        </DateRangeProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
